import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListCareskillComponent } from './list-careskill/list-careskill.component';
import { CareskillModalAjoutComponent } from './modal/careskill-modal-ajout/careskill-modal-ajout.component';
import { CareskillModalDetailComponent } from './modal/careskill-modal-detail/careskill-modal-detail.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';

@NgModule({
	declarations: [
		ListCareskillComponent,
		CareskillModalAjoutComponent,
		CareskillModalDetailComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class CareskillsModule {}
